/*eslint-disable*/
import { data } from 'jquery';
import React, { useState, useEffect } from 'react'
import { Modal } from 'semantic-ui-react'
import Axios from 'axios';
import AddTitleBar from "../../components/titleBar/add_titleBar";
import APP_CONSTANTS from '../../config/constants';
import AgGridTableWithLoader from '../../components/agGridComponent/agGridTableWithLoader';


function FuelMileage(props) {
  const [vehicleData, setVehicleData] = useState([])
  const [vehicleNums, setvehicleNums] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {

    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')
    let data = JSON.stringify
      ({
        api_token: token,
        customerNumber: customerNo,
        userId: userId
      })
    // console.log(APP_CONSTANTS)
    Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vehicleMaster`, data, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    }).then((response => {
      let vehicleList = response.data.resultSet
      let vehicleOptions = []
      if (vehicleList && vehicleList.length > 0) {
        vehicleList.map((object, index) => {
          let temp = {}
          temp.key = object.vehicleMasterId
          temp.text = object.vehicleNumber
          temp.value = object.vehicleMasterId
          vehicleOptions.push(temp)
        })

        setvehicleNums(vehicleOptions)
      }

    }))
      .catch(error => console.log(error))

  }, [])

  const searchVehicleData = (vehicleNoId) => {

    setIsLoading(true)

    let token = localStorage.getItem('apiToken')

    let data = {
      "customerNo": localStorage.getItem('customerNo'),
      "userId": localStorage.getItem('userId'),
      "vehicleId": vehicleNoId.toString()
    }

    Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/report/getFuelMileageReport`, data, {
      headers: {
        'Accept': 'application/json',
        "Authorization": token,
        'Content-Type': 'application/json'
      }
    })
      .then((response => {
        setVehicleData(response.data)
        setIsLoading(false)
      }))
      .catch(error => { console.log(error); setIsLoading(false); })
  }

  let columnDefs = [
    { headerName: 'Date', field: 'vehicleInDate', tooltipField: 'vehicleInDate', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Slip No', field: 'jobCardNo', tooltipField: 'jobCardNo', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Bill No', field: 'invoiceNo', tooltipField: 'invoiceNo', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Fuel/Volume', field: 'quantity', tooltipField: 'quantity', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Rate', field: 'rate', tooltipField: 'rate', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Odometer', field: 'meterReading', tooltipField: 'meterReading', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Amount', field: 'fuelCost', tooltipField: 'fuelCost', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Total Kms	Avg', field: 'fuelMileage', tooltipField: 'fuelMileage', enableRowGroup: true, enablePivot: true, filter: true },
  ]
  let rowData = []

  vehicleData.map((object, i) => {
    let temp = {}
    temp.vehicleInDate = object.vehicleInDate
    temp.rate = object.rate
    temp.fuelMileage = object.fuelMileage
    temp.fuelCost = object.fuelCost
    temp.invoiceNo = object.invoiceNo
    temp.totalKms = object.totalKms
    temp.quantity = object.quantity
    temp.meterReading = object.meterReading
    temp.jobCardNo = object.jobCardNo
    rowData[i] = temp
  })

  return (
    <React.Fragment>
      {/* <div id="dispatch_bar">
        <AddTitleBar
          Title={"Fuel Mileage"}
          LinkName="/fuelmileage"
        />
      </div> */}

      <AgGridTableWithLoader
        columnDefs={columnDefs}
        rowData={rowData}
        searchValue={props.searchValue}
        callVehicleSearch={true}
        loading={true}
        //reload={getUpdate}
        link="#"
        showCTATitle={false}
        hiddenNew={true}
        newPopup={props.newPopup}
        vehicleOptions={vehicleNums}
        isLoading={isLoading}
        searchVehicleData={searchVehicleData}
        titleBarTitle="Fuel Mileage"
        handleSearch={props.handleSearch}
      />


    </React.Fragment>
  )
}

export default FuelMileage
